import {
  CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_STARTED,
  CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_ENQUEUE_STARTED,
  CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
  CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_PROGRESSED,
  CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_FAILED,
} from '@packages/systems/designer/actions';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import {createAction} from '@packages/utilities/create-action';
import type {
  CreateComponentPropertyPendingPayload,
  CreateComponentPropertyItem,
} from '@packages/systems/localization-types';
import type {Qualified} from '@packages/systems/wfdl-Qualified';
import type {Component} from '@packages/systems/wfdl';

export const createComponentPropertyAcrossLocalesStarted = createAction<
  typeof CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_STARTED,
  CreateComponentPropertyPendingPayload
>(CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_STARTED);

export type CreateComponentPropertyAcrossLocalesStartedAction =
  DesignerActionFromCreator<typeof createComponentPropertyAcrossLocalesStarted>;

export const createComponentPropertyAcrossLocalesEnqueueStarted = createAction<
  typeof CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_ENQUEUE_STARTED,
  {
    componentType: Qualified<Component.ComponentName>;
    props: CreateComponentPropertyItem[];
    persistPrimary?: boolean;
  }
>(CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_ENQUEUE_STARTED);

export type CreateComponentPropertyAcrossLocalesEnqueueStartedAction =
  DesignerActionFromCreator<
    typeof createComponentPropertyAcrossLocalesEnqueueStarted
  >;

export const createComponentPropertyAcrossLocalesEnqueueSucceeded =
  createAction<
    typeof CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
    {taskId: string}
  >(CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_ENQUEUE_SUCCEEDED);

export type CreateComponentPropertyAcrossLocalesEnqueueSucceededAction =
  DesignerActionFromCreator<
    typeof createComponentPropertyAcrossLocalesEnqueueSucceeded
  >;

export const createComponentPropertyAcrossLocalesProgressed = createAction<
  typeof CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_PROGRESSED,
  {progress: number}
>(CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_PROGRESSED);

export type CreateComponentPropertyAcrossLocalesProgressedAction =
  DesignerActionFromCreator<
    typeof createComponentPropertyAcrossLocalesProgressed
  >;

export const createComponentPropertyAcrossLocalesFailed = createAction<
  typeof CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_FAILED
>(CREATE_COMPONENT_PROPERTY_ACROSS_LOCALES_FAILED);

export type CreateComponentPropertyAcrossLocalesFailedAction =
  DesignerActionFromCreator<typeof createComponentPropertyAcrossLocalesFailed>;
